/**
 * 시뮬레이션 매장 (id=36) 전용 API 유틸.
 * unionApi / okdcApi 의 시뮬용 분기를 떼어내서 여기로 응집.
 *
 * 모든 호출은 /api/simulation/* 라우트를 사용. storeCode / storeId 불필요
 * (백엔드가 SIM_STORE_ID + SIM_TABLE_CD 상수로 고정).
 */

export const simApi = {
  /**
   * 테이블 가용성 확인 — 시뮬 매장은 항상 비어있음 (tableUse: 'N').
   */
  async checkTableAvailability() {
    const r = await fetch('/api/simulation/availability', { method: 'POST' });
    return await r.json();
  },

  /**
   * 테이블에 기존 주문 존재 여부 — Redis sim_orders LIST 길이로 판별.
   * 첫 주문이면 false, 추가 주문이면 true.
   */
  async checkTableOrderExists() {
    const r = await fetch('/api/simulation/order/check', { method: 'POST' });
    return await r.json();
  },

  /**
   * 누적된 시뮬 주문 내역 조회 (orderList).
   */
  async fetchTableOrderDetail() {
    const r = await fetch('/api/simulation/order/detail', { method: 'POST' });
    return await r.json();
  },

  /**
   * 주문 전송 — Redis 누적 저장 + 'simulation' room 에 sim-order emit.
   */
  async sendOrder({ hasOrder, notificationItems = [], notificationTotalPrice = 0 }) {
    const r = await fetch('/api/simulation/order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        hasOrder,
        notificationItems,
        notificationTotalPrice,
      }),
    });
    return await r.json();
  },

  /**
   * 직원호출 전송 — 'simulation' room 에 sim-staff-call emit.
   * @param {{ callItems: string[] }} payload  선택한 호출 사유 라벨 배열
   */
  async sendStaffCall({ callItems = [] } = {}) {
    const r = await fetch('/api/simulation/staff-call', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ callItems }),
    });
    return await r.json();
  },

  /**
   * 시뮬 상태 초기화 (Redis 모든 키 삭제).
   */
  async reset() {
    const r = await fetch('/api/simulation/reset', { method: 'POST' });
    return await r.json();
  },

  // ============== 리뷰 흐름 ==============

  /**
   * 리뷰 약속 mark 상태 조회 — orderPage 의 page-load 체크용.
   * 본 API /api/review/first-visit-status 의 시뮬 버전.
   */
  async getFirstVisitStatus() {
    const r = await fetch('/api/simulation/review/first-visit-status');
    return await r.json();
  },

  /**
   * 리뷰 약속 등록 — cartDrawer 의 willReview 흐름에서 호출.
   * 본 API /api/review/mark-first-visit 의 시뮬 버전.
   */
  async markFirstVisit({ orderNumber, benefitMenuId, benefitMenuName, benefitImageUrl }) {
    const r = await fetch('/api/simulation/review/mark-first-visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber, benefitMenuId, benefitMenuName, benefitImageUrl }),
    });
    return await r.json();
  },
};

export default simApi;
